import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { IBreed } from "@framework/types";
import { BreedLimitButton } from "@framework/shared";
import { List } from "@dzambalaorg/ui-kit";

import { BreedItemDialogView } from "./view";

const BREEDS_DIALOG_KEY = "breedBreeds";
const BREEDS_URL = "/breed/breeds";

export const BreedBreeds = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IBreed>
  >(BREEDS_URL, { enableInfiniteScroll: isMd });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IBreed>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "breed", "breed.breeds"]} />

      <PageHeader message="pages.breed.breeds.title">
        <BreedLimitButton />
      </PageHeader>

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(breed => (
            <StyledListItem key={breed.id}>
              {}
              <List.ItemText>{`${breed.token.template?.title} #${breed.token.tokenId} breeds count: ${breed.count}`}</List.ItemText>
              <ListActions>
                <ListAction
                  onClick={handleView(BREEDS_DIALOG_KEY, breed, "view")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <BreedItemDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${BREEDS_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
